module.exports = __webpack_public_path__ + "static/a-xx-226-art-622adb149db8048d976abd8ffc668b87.jpg";